import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {  Container } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "./components/Header";
import Home from "./pages/Home";
import App from "./App";
import {auth} from "./api/fbConfig";
import "./index.css";
import theme from "./theme"; // Import the theme

import NotFound from "./pages/NotFound"; // Import the 404 page



//import { initializeApp } from "firebase/app";

//const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

//const db = firebase.firestore();








const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>    <ThemeProvider theme={theme}>

<App/>

      </ThemeProvider>
        </React.StrictMode>
);
